import { BaseFaxMedicalRequestComposite } from "@/Common/Models/Faxing/BaseFaxMedicalRequestComposite";
import { FaxLabRequestComposite } from "@/Common/Models/Faxing/FaxLabRequestComposite";
import { MedicalRequestType } from "@/Common/Models/MedicalRequest/Enum/MedicalRequestType";
import { FaxAndSignatureClinicianSelectionState } from "@/ExportableFile/Components/FaxAndSignatureClinicianSelection";
import { FaxConsultationRequestComposite } from "@/ExportableFile/Models/FaxConsultationRequestComposite";
import { ConsultationRequestAction, IMedicalRequestAction, LabRequestAction } from "./MedicalRequestAction";
import { ConsultationRequestHandler, IHandleMedicalRequest, LabRequestHandler } from "./MedicalRequestHandler";

class MedicalRequestFactory {
    public static createAction(type: MedicalRequestType): IMedicalRequestAction {
        switch (type) {
            case MedicalRequestType.ConsultationRequest:
                return ConsultationRequestAction.getInstance();
            case MedicalRequestType.LabRequest:
                return LabRequestAction.getInstance();
        }
        return null;
    }

    public static createHandler(type: MedicalRequestType): IHandleMedicalRequest {
        switch (type) {
            case MedicalRequestType.ConsultationRequest:
                return new ConsultationRequestHandler();
            case MedicalRequestType.LabRequest:
                return new LabRequestHandler();
        }
        return null;
    }

    public static createFaxComposite(
        type: MedicalRequestType,
        id?: string,
        patientId?: string,
        fileName?: string,
        clinicianInfoState?: FaxAndSignatureClinicianSelectionState,
        labName?: string,
        labFax?: string,
        labPhone?: string,
        labAddress?: string
    ): BaseFaxMedicalRequestComposite {
        switch (type) {
            case MedicalRequestType.ConsultationRequest:
                return new FaxConsultationRequestComposite(id, patientId, fileName, clinicianInfoState);
            case MedicalRequestType.LabRequest:
                return new FaxLabRequestComposite({
                    Id: id,
                    PatientId: patientId,
                    FileName: fileName,
                    LabName: labName,
                    LabFax: labFax,
                    LabPhone: labPhone,
                    LabAddress: labAddress
                });
            default:
                return null;
        }
    }
}

export { MedicalRequestFactory };
